import axios from 'axios/index';
import React, {Component} from 'react';
import {Route, Switch, Redirect, NavLink, Link} from 'react-router-dom';
import {getCurrentUserId, getJwt} from '../../services/authService';
import http from '../../services/httpService';
import NoFeeds from "./feed/NoFeeds";
// import ReactGA from "react-ga";
import {
    Popover, Classes, Position, Menu, MenuDivider, MenuItem, Button, Icon, Tooltip
} from "@blueprintjs/core";

import FBMessengerCampaignPerformance from './campaignPerformanceComponents/FBMessengerCampaignPerformance';
import SMSCampaignPerformance from './campaignPerformanceComponents/SMSCampaignPerformance'

import WebPushCampaignPerformance from './campaignPerformanceComponents/WebPushCampaignPerformance';
import ViberCampaignPerformance from './campaignPerformanceComponents/ViberCampaignPerformance';
import FBAdsCampaignPerformance from './campaignPerformanceComponents/FBAdsCampaignPerformance';

import WhatsAppCampaignPerformance from './campaignPerformanceComponents/WhatsAppCampaignPerformance';
import URLShortenerPerformance from './URLShortenerPerformance';

const facebook_app_graph_url = process.env.REACT_APP_FB_URL;
const facebook_app_marketing_url = process.env.REACT_APP_FB_MARKETING_URL;

class CampaignPerformance extends Component {
    state = {
        user: this.props.user,
        fb_user_id: '',
        showTestFunctionalities: false,
        adAccounts: [],
        selectedAdAccount: '',
        selectedAdAccountName: '',
        extendedAccessToken: '',
        fbAdsManagementPermission: false,
        campaign_performance_selector: {
            main_type: '',
            sub_type: '',
            type: '',
            selected_fb_page: ''
        },
        arrayOfMainTypes: [
            {
                name: 'SMS',
                icon: '/img/channels/sms-icon.svg',
                sub_types: [
                    {
                        name: 'Campaigns',
                        icon: '',
                    },
                    {
                        name: 'Scheduled',
                        icon: ''
                    }

                ]
                // sub_types: [
                //     {
                //         name: 'Show All',
                //         icon: ''
                //     }
                // ]
            },
            {
                name: 'Webpush',
                icon: '/img/channels/notification-icon.svg',
                sub_types: [
                    {
                        name: 'Show All',
                        icon: ''
                    },
                    {
                        name: 'Autopush',
                        //icon: '/img/campaignPerformance/auto_push_icon.png'
                    },
                    {
                        name: 'Instant Push',
                        //icon: '/img/campaignPerformance/instant_push_icon.png'
                    }
                ]
            },
            // {
            //     name: 'Viber',
            //     icon_class_name: 'fab fa-viber',
            //     sub_types: [
            //         {
            //             name: 'Show All',
            //             icon: ''
            //         },
            //         {
            //             name: 'Autopush',
            //             //icon: '/img/campaignPerformance/auto_push_icon.png'
            //         },
            //         {
            //             name: 'Instant Push',
            //             //icon: '/img/campaignPerformance/instant_push_icon.png'
            //         }
            //     ]
            //     ,
            //     selected_brand: ''
            // },
            {
                name: 'Messenger',
                icon: '/img/channels/messenger-icon.svg',
                sub_types: [
                    {
                        name: 'Campaigns',
                        icon: '',
                        types: [
                            {
                                name: 'Single Message'
                            },
                            {
                                name: 'Carousel Message'
                            }
                        ]
                    },
                    {
                        name: 'Scheduled',
                        icon: '',
                        types: [
                            {
                                name: 'Single Message'
                            },
                            {
                                name: 'Carousel Message'
                            }
                        ]
                    }

                ]

                //     {
                //         name: 'Single Message',
                //         // types: [
                //         //     {
                //         //         name: 'Show All',
                //         //         icon: ''
                //         //     },
                //         //     {
                //         //         name: 'Autopush',
                //         //         //icon: '/img/campaignPerformance/auto_push_icon.png'
                //         //     },
                //         //     {
                //         //         name: 'Instant Push',
                //         //         //icon: '/img/campaignPerformance/instant_push_icon.png'
                //         //     }
                //         // ],
                //         //icon: '/img/campaignPerformance/single_custom_link_icon.png'
                //     },
                //     {
                //         name: 'Carousel Message',
                //         // types: [
                //         //     {
                //         //         name: 'Show All',
                //         //         icon: ''
                //         //     },
                //         //     {
                //         //         name: 'Autopush',
                //         //         //icon: '/img/campaignPerformance/auto_push_icon.png'
                //         //     },
                //         //     {
                //         //         name: 'Instant Push',
                //         //         //icon: '/img/campaignPerformance/instant_push_icon.png'
                //         //     }
                //         // ],
                //         //icon: '/img/campaignPerformance/multiple_custom_link_icon.png'
                //     },
                //     // {
                //     //     name: 'Text Message',
                //     //     //icon: '/img/campaignPerformance/text_message_icon.png'
                //     // }
                //
                // ]
            },
            {
                name: 'Facebook Ads',
                icon: '/img/channels/messenger-icon.svg',
                sub_types: [
                    {
                        name: 'Sponsored Message',
                        icon: '/img/channels/messenger-icon.svg',
                    },
                    {
                        name: 'Acquire Subscribers',
                        icon: '/img/channels/messenger-icon.svg'
                    }

                ],
                selected_fb_page: ''
            },
            {
                name: 'Viber',
                icon: '/img/channels/viber-icon.svg',
                sub_types: [
                    {
                        name: 'Campaigns',
                        icon: '',
                    },
                    {
                        name: 'Scheduled',
                        icon: ''
                    }

                ]
            },
            {
                name: 'URL Analytics',
                icon_font_awesome: <i className="fas fa-link type-icon" style={{color: '#344A5E'}}></i>
            }

        ],
        selected_main_type: {
            name: 'SMS',
            icon: '/img/channels/sms-icon.svg',
        },
        selected_sub_type: {
            name: "Show All"
        },
        selected_type: {}
    }

    setMultipost = () => {
        localStorage.setItem('multipost', 'true')

    };

    componentDidMount = async () => {
        // ReactGA.pageview(window.location.pathname + window.location.search);

        //console.log('campaignPerformance cdm')

        const user_id = await getCurrentUserId();
        //const result = await http.get('api/user_info', {headers: {authorization: getJwt()}});
        const user = await this.state.user;

        // const showTestFunctionalities = await (user_id === '1') || (user_id === '25') || (user_id === '150' || (user_id === '141') ||
        //     (user_id === '108') || (user_id === '355') || (user_id === '332') || (user_id === '154') || (user_id === '352')
        //     || (user_id === '353') || (user_id === '329') || (user_id === '156') || (user_id === '363')) ? true : false;

        let selected_main_type = await localStorage.getItem('selected_main_type');
        //console.log('selected_main_type: ', selected_main_type)
        let selected_sub_type = await localStorage.getItem('selected_sub_type');
        let selected_type = await localStorage.getItem('selected_type');
        let facebook_platform_enabled = this.props.platforms_enabled && this.props.platforms_enabled.indexOf("fb") > -1;
        await this.setState({
            user,
            // showTestFunctionalities,
            selected_main_type: selected_main_type ? JSON.parse(selected_main_type) : this.state.selected_main_type !== '' ? this.state.selected_main_type : 'SMS',
            selected_sub_type: selected_sub_type ? JSON.parse(selected_sub_type) : this.state.selected_sub_type,
            selected_type: selected_type ? JSON.parse(selected_type) : '',
        })
        //console.log('state set')
        let channel = window.location.pathname.split('my-campaigns/')[1]
        if (!channel) {
            channel = 'sms'
        }
        if (document.querySelector('#' + channel)) {
            await setTimeout(document.querySelector('#' + channel).click(), 500)
        }
        if (user.user_fb_id && window.location.pathname === '/my-campaigns/fb-messenger-campaigns' && facebook_platform_enabled) {
            //console.log('its  messenger campaigns')
            await this.checkAdsManagementPermission(user.user_fb_id, user.user_fb_extended_token);
            // console.log(this.state.fbAdsManagementPermission)
            if (this.state.fbAdsManagementPermission) {
                const fbAdAccounts = await axios.get(facebook_app_marketing_url + 'me/adaccounts?access_token=' + user.user_fb_extended_token + '&fields=name,owner,account_id,business_name');
                // console.log('Fb fbAdAccounts response: ', fbAdAccounts)
                if (fbAdAccounts) {
                    await this.setState({
                        adAccounts: fbAdAccounts.data.data
                    })
                    if (!user.add_account_id && fbAdAccounts.data.data.length > 0) {
                        await this.selectAdAccount(fbAdAccounts.data.data[0])
                        await this.setState({
                            selectedAdAccount: fbAdAccounts.data.data[0].id,
                            selectedAdAccountName: fbAdAccounts.data.data[0].name
                        })
                    } else if (user.add_account_id) {
                        const userAdAccount = await fbAdAccounts.data.data.find(account => account.id === user.add_account_id)
                        if (userAdAccount) {
                            await this.setState({
                                selectedAdAccount: user.add_account_id,
                                selectedAdAccountName: userAdAccount.name
                            })
                        }
                    }
                }
            }
        } else {
            //console.log('its not messenger campaigns')
        }
    }

    componentDidUpdate = async () => {

        if (window.location.pathname === '/my-campaigns') {

            let selected_main_type = localStorage.getItem('selected_main_type') ? await JSON.parse(localStorage.getItem('selected_main_type')) : this.state.selected_main_type;

            if (selected_main_type.name && selected_main_type.name !== '' && selected_main_type.name !== null) {
                await this.props.history.push("/my-campaigns/" + (selected_main_type.name === 'Messenger' ?
                    'fb-messenger' : selected_main_type.name === 'Facebook Ads' ? 'fb-messenger-campaigns' :
                        selected_main_type.name === 'SMS' ? 'sms' : selected_main_type.name === 'Webpush' ? 'web-push' :
                            selected_main_type.name === 'Viber' ? 'viber' : 'url-analytics'));
            } else {
                await this.props.history.push("/my-campaigns/SMS")
            }

            // let channel = window.location.pathname.split('my-campaigns/')[1]
            // if (!channel) {
            //     channel = 'sms'
            // }
            // if (document.querySelector('#' + channel)) {
            //     await setTimeout(document.querySelector('#' + channel).click(), 500)
            // }
        }

        if (this.state.user !== this.props.user) {
            this.setState({
                user: this.props.user
            })
        }
    }

    responseFacebook = async (response) => {
        const user_id = await getCurrentUserId();
        //const resp = await http.get('api/user_info', {headers: {authorization: getJwt()}});
        const user = await this.state.user
        await this.setState({
            user: user
        })
        try {
            // console.log('Facebook user id: ', response)
            this.checkAdsManagementPermission(response.id, response.accessToken)
            /* Get facebook accounts, returns each account Id and Name */
            if (this.state.fbAdsManagementPermission) {
                const fbAdAccounts = await axios.get(facebook_app_marketing_url + 'me/adaccounts?access_token=' + this.state.user.user_fb_extended_token + '&fields=name,owner,account_id,business_name');
                if (fbAdAccounts) {
                    await this.setState({
                        adAccounts: fbAdAccounts.data.data
                    })
                    if (!this.state.user.selectedAdAccount) {

                    }
                    this.selectAdAccount(fbAdAccounts.data.data[0])
                }
            }
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                this.setState({
                    errorMessage: ex.response.data.message
                })
            if (ex.response && ex.response.status === 401) {
                this.setState({
                    errorMessage: ex.response.data.message
                })
            }
        }
    }


    checkAdsManagementPermission = async (user_fb_id, user_fb_extended_token) => {
        if (user_fb_id && user_fb_extended_token) {
            try {
                const fbUserPermissions = await axios.get(facebook_app_graph_url + user_fb_id + '/permissions?access_token=' + user_fb_extended_token);
                const fbAdsManagementPermission = await fbUserPermissions.data.data.find(item => item.permission === 'ads_management');
                if (fbAdsManagementPermission) {
                    await this.setState({
                        fbAdsManagementPermission: (fbAdsManagementPermission.status === 'granted') ? true : false
                    })
                }
                // console.log('permissions: ', fbUserPermissions, this.state.fbAdsManagementPermission)
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    this.setState({
                        errorMessage: ex.response.data.message
                    })
                if (ex.response && ex.response.status === 401) {
                    this.setState({
                        errorMessage: ex.response.data.message
                    })
                }
            }
        }
    }

    selectAdAccount = async (account) => {
        const result = await http.post('api/sponsored_facebook/user/' + getCurrentUserId() + '/adaccounts', {add_account_id: account.id}, {headers: {authorization: getJwt()}});

        if (result.data.account_selected) {
            await this.setState({
                selectedAdAccount: result.data.account_selected,
                selectedAdAccountName: account.name,
                user: {
                    ...this.state.user,
                    add_account_id: result.data.account_selected
                }
            })
        }
    }

    selectMainType = async (data) => {
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Campaign Performance - selected main type: ' + {data},
        //     userId: getCurrentUserId(),
        //     label: '',
        //     nonInteraction: true
        // });
        await this.setState({
            selected_main_type: data,
            selected_sub_type: data.sub_types ? data.sub_types[0] : '',
            selected_type: data.sub_types ? data.sub_types[0].types ? data.sub_types[0].types[0] : '' : ''
        })
        await localStorage.setItem('selected_main_type', JSON.stringify(this.state.selected_main_type));
        await localStorage.setItem('selected_sub_type', JSON.stringify(this.state.selected_sub_type))
        await localStorage.setItem('selected_type', JSON.stringify(this.state.selected_type))
    }

    selectSubType = async (data) => {
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Campaign Performance - selected sub type: ' + {data},
        //     userId: getCurrentUserId(),
        //     label: '',
        //     nonInteraction: true
        // });
        await this.setState({
            selected_sub_type: data,
            selected_type: data.types ? data.types[0] : ''
        })

        await localStorage.setItem('selected_sub_type', JSON.stringify(this.state.selected_sub_type))
        await localStorage.setItem('selected_type', JSON.stringify(this.state.selected_type))
    }

    selectType = async (data) => {
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Campaign Performance - selected  type: ' + {data},
        //     userId: getCurrentUserId(),
        //     label: '',
        //     nonInteraction: true
        // });
        await this.setState({
            selected_type: data
        })

        await localStorage.setItem('selected_type', JSON.stringify(this.state.selected_type))
    }

    render() {
        const facebook_app_id = process.env.REACT_APP_FACEBOOK_APP_ID;

        return (
            <React.Fragment>


                <h1 className='main-title'>My Campaigns</h1>
                {this.props.sources.length
                    //|| this.props.feeds_shared.length
                    ?
                    <React.Fragment>

                        <div className="tabs-navigation my-campaigns-nav ">

                            {this.state.arrayOfMainTypes.map(
                                mainType => <NavLink key={mainType.name === 'Messenger' ?
                                    'fb-messenger' : mainType.name === 'Facebook Ads' ? 'fb-messenger-campaigns' :
                                        mainType.name === 'SMS' ? 'sms' : mainType.name === 'Webpush' ? 'web-push' :
                                            mainType.name === 'Viber' ? 'viber' : 'whatsapp-campaigns'}
                                                     to={"/my-campaigns/" + (mainType.name === 'Messenger' ?
                                                             'fb-messenger' : mainType.name === 'Facebook Ads' ? 'fb-messenger-campaigns' :
                                                                 mainType.name === 'SMS' ? 'sms' : mainType.name === 'Webpush' ? 'web-push' :
                                                                     mainType.name === 'Viber' ? 'viber' : mainType.name === 'URL Analytics' ? 'url-analytics' : 'whatsapp-campaigns'
                                                     )}
                                                     id={
                                                         mainType.name === 'Messenger' ?
                                                             'fb-messenger' : mainType.name === 'Facebook Ads' ? 'fb-messenger-campaigns' :
                                                                 mainType.name === 'SMS' ? 'sms' : mainType.name === 'Webpush' ? 'web-push' :
                                                                     mainType.name === 'Viber' ? 'viber' : mainType.name === 'URL Analytics' ? 'url-analytics' : 'whatsapp-campaigns'}
                                                     onClick={() => this.selectMainType(mainType)}
                                                     className={mainType.name === this.state.selected_main_type.name ? "navigation-tab active" : "navigation-tab"}>
                                    {mainType.icon_class_name ? < i className={mainType.icon_class_name}/> :
                                        mainType.icon ? <img style={{marginRight: 10}} src={mainType.icon}/> :
                                            mainType.icon_font_awesome}
                                    {mainType.name}
                                </NavLink>
                            )}
                        </div>
                        <div className="display-flex subtypes-container">

                            {/*{this.state.selected_main_type.name === 'Messenger' || 'Viber' ?*/}
                            {/*    <div className="tabs-navigation">*/}

                            {/*        <div className="navigation-tab active">*/}
                            {/*            Campaigns*/}
                            {/*        </div>*/}
                            {/*        <Tooltip content="Coming Soon!" position={Position.BOTTOM}>*/}
                            {/*            <div className="navigation-tab disabled">*/}
                            {/*                Scheduled*/}
                            {/*            </div>*/}
                            {/*        </Tooltip>*/}
                            {/*    </div>*/}
                            {/*    :*/}
                            {/*    ''}*/}
                            <div className="tabs-navigation">
                                {(this.state.selected_main_type.name === 'Facebook Ads') && this.state.fbAdsManagementPermission && this.state.adAccounts && this.state.adAccounts.length > 1 ?
                                    <div className="fb-ad-account-selector">

                                        <Popover content={
                                            <Menu className={Classes.ELEVATION_1}>
                                                {this.state.adAccounts.map(account => <MenuItem
                                                    onClick={() => this.selectAdAccount(account)}
                                                    text={account.name} label={account.id}/>
                                                )}
                                            </Menu>} position={Position.BOTTOM}>
                                            <div className='padding-10'
                                            ><p>{this.state.selectedAdAccountName + ' '}
                                                <span>ID: {this.state.user.add_account_id ? this.state.user.add_account_id.substring(4) : 'Id not selected'} </span><Icon
                                                    color="#344A5E" icon="caret-down"/></p>
                                            </div>
                                            {/*<Button rightIcon="caret-down" text={ this.state.selectedAdAccountName + ' - ' + this.state.user.add_account_id }/>*/}
                                        </Popover>
                                    </div>
                                    :
                                    null
                                }
                                {this.state.selected_main_type.sub_types && this.state.selected_main_type.name !== 'URL SHORTENER' ?
                                    this.state.selected_main_type.sub_types.map(
                                        subType => <div key={subType.name}
                                                        onClick={() => this.selectSubType(subType)}
                                                        className={subType.name === this.state.selected_sub_type.name ? "navigation-tab active" : "navigation-tab"}>
                                            {subType.icon ? <img src={subType.icon}/> : null}
                                            {subType.icon_class_name ?
                                                < i className={subType.icon_class_name}/> : null}
                                            <p>{subType.name}</p>
                                        </div>)
                                    :
                                    ''
                                }
                            </div>
                            {this.state.selected_sub_type.types ?
                                <div className="tabs-navigation">
                                    {this.state.selected_sub_type.types.map(
                                        type => <div
                                            key={type.name} onClick={() => this.selectType(type)}
                                            className={type.name === this.state.selected_type.name ? "navigation-tab active" : "navigation-tab"}>
                                            {type.icon ? <img src={type.icon}/> : null}
                                            {type.icon_class_name ?
                                                < i className={type.icon_class_name}/> : null}
                                            <p>{type.name}</p>
                                        </div>)}

                                </div>
                                : null
                            }
                        </div>
                        <Switch>
                            <Route path="/my-campaigns/fb-messenger"
                                   render={(props) => <FBMessengerCampaignPerformance
                                       user={this.state.user}
                                       selectedSource={this.props.selectedSource}
                                       selectedSourceName={this.props.selectedSourceName}
                                       adAccounts={this.state.adAccounts}
                                       selectAdAccount={this.selectAdAccount}
                                       selectedAdAccount={this.state.user.add_account_id}
                                       selectedAdAccountName={this.state.selectedAdAccountName}
                                       selectedSubType={this.state.selected_sub_type}
                                       selectedType={this.state.selected_type}
                                       history={this.props.history}
                                       user_facebook_pages={this.props.user_facebook_pages}
                                       facebook_pages_shared={this.props.facebook_pages_shared}
                                       isodateToDate={this.props.isodateToDate}
                                   />
                                   }
                            />

                            <Route path="/my-campaigns/fb-messenger-campaigns"
                                   render={(props) => <FBAdsCampaignPerformance
                                       user={this.state.user}
                                       fbAdsManagementPermission={this.state.fbAdsManagementPermission}
                                       checkPermissions={() => this.checkAdsManagementPermission(this.state.user.user_fb_id, this.state.user.user_fb_extended_token)}
                                       selectedSource={this.props.selectedSource}
                                       selectedSourceName={this.props.selectedSourceName}
                                       adAccounts={this.state.adAccounts}
                                       selectAdAccount={this.selectAdAccount}
                                       selectedAdAccount={this.state.user.add_account_id}
                                       selectedAdAccountName={this.state.selectedAdAccountName}
                                       selectedCampaignPerformance={this.state.selected_sub_type.name === 'Sponsored Message' ? 'MESSAGES' : 'LINK_CLICKS'}
                                       history={this.props.history}
                                       isodateToDate={this.props.isodateToDate}
                                   />
                                   }
                            />

                            <Route path="/my-campaigns/sms"
                                   render={(props) => <SMSCampaignPerformance
                                       user={this.state.user}
                                       selectedSource={this.props.selectedSource}
                                       selectedSourceName={this.props.selectedSourceName}
                                       adAccounts={this.state.adAccounts}
                                       selectAdAccount={this.selectAdAccount}
                                       selectedAdAccount={this.state.user.add_account_id}
                                       selectedAdAccountName={this.state.selectedAdAccountName}
                                       selectedSubType={this.state.selected_sub_type}
                                       selectedType={this.state.selected_type}
                                       history={this.props.history}
                                       isodateToDate={this.props.isodateToDate}
                                   />
                                   }
                            />


                            <Route path="/my-campaigns/web-push"
                                   render={(props) => <WebPushCampaignPerformance
                                       user={this.state.user}
                                       selectedSource={this.props.selectedSource}
                                       selectedSourceName={this.props.selectedSourceName}
                                       adAccounts={this.state.adAccounts}
                                       selectAdAccount={this.selectAdAccount}
                                       selectedAdAccount={this.state.user.add_account_id}
                                       selectedAdAccountName={this.state.selectedAdAccountName}
                                       selectedSubType={this.state.selected_sub_type}
                                       selectedType={this.state.selected_type}
                                       platforms_enabled={this.props.platforms_enabled}
                                       history={this.props.history}
                                       isodateToDate={this.props.isodateToDate}
                                   />
                                   }
                            />

                            <Route path="/my-campaigns/viber"
                                   render={(props) => <ViberCampaignPerformance
                                       user={this.props.user}
                                       selectedSource={this.props.selectedSource}
                                       selectedSourceName={this.props.selectedSourceName}
                                       selectedSourceNode={this.props.selectedSourceNode}
                                       adAccounts={this.state.adAccounts}
                                       selectAdAccount={this.selectAdAccount}
                                       selectedAdAccount={this.state.user.add_account_id}
                                       selectedAdAccountName={this.state.selectedAdAccountName}
                                       selectedSubType={this.state.selected_sub_type}
                                       selectedType={this.state.selected_type}
                                       history={this.props.history}
                                       isodateToDate={this.props.isodateToDate}
                                   />

                                   }
                            />
                            <Route path="/my-campaigns/url-analytics"
                                   render={() => <URLShortenerPerformance
                                       {...this.props}
                                       selectedSource={this.props.selectedSource}
                                       history={this.props.history}
                                       editShortenedUrl={(rowIndex, shownUrls) => this.props.history.push('/url/shortener', {
                                           editShortUrl: {
                                               rowIndex,
                                               shownUrls
                                           }
                                       })}
                                   />}
                            />
                            {/*<Route path="/my-campaigns/whatsapp-campaigns"*/}
                            {/*       render={(props) => <WebPush*/}
                            {/*           user={this.state.user}*/}
                            {/*           selectedSource={this.props.selectedSource}*/}
                            {/*           adAccounts={this.state.adAccounts}*/}
                            {/*           selectAdAccount={this.selectAdAccount}*/}
                            {/*           selectedAdAccount={this.state.user.add_account_id}*/}
                            {/*           selectedAdAccountName={this.state.selectedAdAccountName}*/}
                            {/*           selectedSubType={this.state.selected_sub_type}*/}
                            {/*           selectedType={this.state.selected_type}*/}
                            {/*       />*/}

                            {/*       }*/}
                            {/*/>*/}
                            {/*<Route path="/my-Campaigns/url-shortener"*/}
                            {/*       render={(props) => <URLShortenerPerformance*/}
                            {/*           selectedSource={this.props.selectedSource}*/}
                            {/*           history={this.props.history}*/}
                            {/*       />*/}
                            {/*       }/>*/}
                        </Switch>

                    </React.Fragment> :
                    <NoFeeds userFullName={this.props.userFullName}/>
                }
            </React.Fragment>
        )
    }
}

export default CampaignPerformance;
